const RETAIL_STORE_DETAILS = {
  'bk.joybird.com': { id: '1', name: 'Brooklyn', zipCode: '11201' },
  'dc.joybird.com': { id: '2', name: 'Washington', zipCode: '20005' },
  'chi.joybird.com': { id: '4', name: 'Chicago', zipCode: '60610' },
  'weho.joybird.com': {
    id: '6',
    name: 'West Hollywood',
    zipCode: '90069',
  },
  'sf.joybird.com': { id: '7', name: 'San Francisco', zipCode: '94102' },
  'atx.joybird.com': { id: '8', name: 'Austin', zipCode: '78758' },
  'sea.joybird.com': { id: '9', name: 'Seattle', zipCode: '98122' },
  'soho.joybird.com': { id: '10', name: 'Manhattan', zipCode: '10012' },
  'phil.joybird.com': { id: '11', name: 'Philadelphia', zipCode: '19102' },
  'la.joybird.com': {
    id: '12',
    name: 'Downtown Los Angeles',
    zipCode: '90021',
  },
  'den.joybird.com': { id: '13', name: 'Denver', zipCode: '80206' },
  'vs.joybird.com': { id: '5', name: 'Virtual Showroom', zipCode: '*' },
  'pdx.joybird.com': { id: '14', name: 'Portland', zipCode: '97209' },
  'cs.joybird.com': { id: '15', name: 'Customer Service', zipCode: '0' },
  'nis.joybird.com': { id: '3', name: 'Nis', zipCode: '-1' },
  'lzbmia.joybird.com': { id: '17', name: 'LZB Miami', zipCode: '-1' },
  'cm.joybird.com': { id: '20', name: 'Costa Mesa, CA', zipCode: '92626' },
  'mv.joybird.com': { id: '19', name: 'Mission Viejo, CA', zipCode: '92691' },
  'col.joybird.com': { id: '21', name: 'Columbus, OH', zipCode: '43219' },
  'scot.joybird.com': { id: '22', name: 'Scottsdale, AZ', zipCode: '85254' },
  'dal.joybird.com': { id: '70', name: 'Dallas', zipCode: '75205' },
  'dp.joybird.com': { id: '72', name: 'Deer Park, IL', zipCode: '60010' },
  'gld.joybird.com': { id: '76', name: 'Glendale, AZ', zipCode: '85308' },
  'cos.joybird.com': {
    id: '77',
    name: 'Colorado Springs, CO',
    zipCode: '80920',
  },
  'nov.joybird.com': { id: '78', name: 'Novi, MI', zipCode: '48377' },
  'pas.joybird.com': { id: '80', name: 'Pasadena, CA', zipCode: '91105' },
  'ffx.joybird.com': { id: '81', name: 'Fairfax, VA', zipCode: '22030' },
  'tc.joybird.com': { id: '82', name: 'Tacoma, WA', zipCode: '98409' },
};

export const normalizeStoreHostname = rawHostname => {
  if (typeof rawHostname !== 'string') return null;

  const hostnameWithOptionalPort = rawHostname.trim().toLowerCase();
  if (!/^[a-z0-9.-]+(?::\d{1,5})?$/.test(hostnameWithOptionalPort)) {
    return null;
  }

  const hostname = hostnameWithOptionalPort.replace(/:\d{1,5}$/, '');
  return hostname.replace(/^([^.]+)\.store\.joybird\.com$/, '$1.joybird.com');
};

export const getStoreDetailsForHostname = rawHostname => {
  const hostname = normalizeStoreHostname(rawHostname);
  const storeDetails = hostname && RETAIL_STORE_DETAILS[hostname];
  return storeDetails ? { ...storeDetails } : null;
};

export const resolveRetailStoreContext = ({
  originalHost,
  cookieStoreHostName,
  isProduction,
}) => {
  const rawHostname =
    (!isProduction && cookieStoreHostName) || originalHost || null;
  const hostname = normalizeStoreHostname(rawHostname);
  const storeDetails = getStoreDetailsForHostname(hostname);

  if (!hostname || !storeDetails) return null;

  return {
    hostname,
    storeDetails,
    includeStoreHostNameCookie: !isProduction,
  };
};

export const buildStoreHeaders = storeContext => {
  const hostname = storeContext?.hostname;

  if (
    typeof hostname !== 'string' ||
    normalizeStoreHostname(hostname) !== hostname ||
    !getStoreDetailsForHostname(hostname)
  ) {
    return {};
  }

  return {
    Origin: `https://${hostname}`,
    ...(storeContext.includeStoreHostNameCookie
      ? { Cookie: `storeHostName=${hostname}` }
      : {}),
  };
};
